import { DISTRIBUTOR } from '@autopass-web/domain';

import { DIST } from '../../config';
import { CoreMapPage } from '../../features/maps/core-map-page';
import { EnterpriseJkoMapPage } from '../../features/maps/enterprise-jko-map-page';
import { EnterprisePiMapPage } from '../../features/maps/enterprise-pi-map-page';
import { HotaiPage } from '../../features/maps/hotai-map-page';
import { PlusPayMapPage } from '../../features/maps/plus-pay-map-page';
import { RichartLifeMapPage } from '../../features/maps/richart-life-map-page';

const Maps = () => {
  switch (DIST) {
    case DISTRIBUTOR.ENTERPRISE_PI:
      return <EnterprisePiMapPage />;
    case DISTRIBUTOR.ENTERPRISE_JKO:
      return <EnterpriseJkoMapPage />;
    case DISTRIBUTOR.CATHAYMR:
    case DISTRIBUTOR.AUTO_PARTNER:
      return <CoreMapPage />;
    case DISTRIBUTOR.MYTOYOTA:
    case DISTRIBUTOR.LEXUS_PLUS:
      return <HotaiPage />;
    case DISTRIBUTOR.PLUS_PAY:
      return <PlusPayMapPage />;
    case DISTRIBUTOR.RICHART_LIFE:
      return <RichartLifeMapPage />;
    default:
      return <CoreMapPage />;
  }
};

export default Maps;
